import axios from "axios";
import params from "../../../config/params";

require("dotenv").config();

let BASE_URL = params.PROD.CLIENT.CUSTOMER.BASE_URL;

if (process.env.NODE_ENV === "development") {
  BASE_URL = params.DEV.CLIENT.CUSTOMER.BASE_URL;
}
if (process.env.NODE_ENV === "qa") {
  BASE_URL = params.QA.CLIENT.CUSTOMER.BASE_URL;
}

const getCustomer = sapcode => {
  return axios.get(`${BASE_URL}/customer/${sapcode}`);
};

export default {
  getCustomer
};
